const { dateUtil, helpers } = require("../../utils");

export const columns = [
  {
    title: "Name",
    dataIndex: "userId",
    key: "userId",
    render: (userId) => (
      <p>
        {userId?.first_name} {userId?.last_name}
      </p>
    ),
  },
  {
    title: "Plan Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Plan Type",
    dataIndex: "type",
    key: "type",
  },
  {
    title: "Returns Type",
    dataIndex: "investmentReturnsType",
    key: "investmentReturnsType",
  },
  {
    title: "active",
    dataIndex: "active",
    key: "active",
    render: (value) => <p>{value ? "Yes" : "No"}</p>,
  },
  {
    title: "Balance",
    dataIndex: "",
    key: "x",
    render: (investment) => {
      const { balance, currency } = investment;
      return <p>{helpers.toCurrency(balance, currency)}</p>;
    },
  },

  {
    title: "Principal Withdrawn",
    dataIndex: "principalWithdrawn",
    key: "principalWithdrawn",
    render: (value) => <p>{value ? "Yes" : "No"}</p>,
  },
  {
    title: "Referral Interest",
    dataIndex: "referralInterestWithdrawn",
    key: "referralInterestWithdrawn",
    render: (value) => <p>{value ? "Withdrawn" : "Not Withdrawn"}</p>,
  },

  {
    title: "Started",
    dataIndex: "startDate",
    key: "startDate",
    render: (startDate) => <p>{dateUtil.formatFullDateTime(startDate)}</p>,
  },
  {
    title: "Ends",
    dataIndex: "endDate",
    key: "endDate",
    render: (endDate) => <p>{dateUtil.formatFullDateTime(endDate)}</p>,
  },
];
